import Inspiration from './Inspiration';

export default Inspiration;
export { Inspiration };
